import { Button } from '@civilgrid/ui/components';
import { useLayerConfigLoadState } from '~/hooks/useLayerConfigLoadState';

/**
 * Failure affordance for the per-user layer config. The picker shows a loader until the document
 * loads (see `TOC.tsx`), so this just surfaces the *failure* case — a real "couldn't load your
 * settings" state with a retry, never a silent fallback. Renders nothing until a load fails. The
 * no-overwrite invariant is enforced by `canPersist`, so edits made before/without a load can't be
 * persisted.
 */
export function LayerConfigStatusBanner() {
  const { hasFailed, retry } = useLayerConfigLoadState();

  if (!hasFailed) return null;

  return (
    <div
      data-testid="layer-config-failed"
      className="flex items-center justify-between gap-2 px-2 py-1 text-sm text-red-60"
    >
      <span>Couldn’t load your layer settings.</span>
      <Button variant="secondary" data-testid="layer-config-retry" onClick={retry}>
        Retry
      </Button>
    </div>
  );
}
